import { Image } from '@acme/assets';

export const DocumentsEmptyState = () => (
  <div className="bg-white border border-gray-200 rounded-lg p-12 flex flex-col items-center justify-center gap-4 text-center">
    <Image
      name="documents"
      width={120}
      height={120}
      className="text-gray-400"
    />
    <div className="flex flex-col gap-1">
      <p className="text-gray-900 font-medium">
        Документы по заданным условиям не найдены
      </p>
    </div>
  </div>
);
